import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import LeaderAvatar from "@/components/ui/LeaderAvatar";
import { leadershipMembers } from "@/data/leadership";

const isPlaceholder = (src: string) => !src || src.includes("placeholder");

export default function LeadershipPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />
      <main id="main-content">
        <section className="pt-16 pb-16 px-6 bg-[#F8F6F3]">
          <div className="max-w-[1280px] mx-auto">
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
              Leadership Team
            </span>
            <h1 className="font-['Cormorant_Garamond'] text-5xl md:text-6xl font-bold text-[#2B2D2F] mb-5">
              Meet the People Leading Harambee
            </h1>
            <p className="text-[#6B6B6B] text-lg max-w-3xl font-light leading-relaxed">
              Our leadership team brings together experience in business,
              technology, education, diplomacy, and international markets.
              Together, they guide Harambee&apos;s strategy and turn its vision
              into practical action.
            </p>
          </div>
        </section>

        <section className="py-24 px-6 bg-white">
          <div className="max-w-[1280px] mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {leadershipMembers.map((member) => (
              <article
                key={member.name}
                className="bg-white border border-[#E8E4DC] rounded-lg overflow-hidden shadow-soft hover:shadow-soft-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="aspect-square overflow-hidden">
                  {isPlaceholder(member.img) ? (
                    <LeaderAvatar name={member.name} variant="light" />
                  ) : (
                    <img
                      loading="lazy"
                      src={member.img}
                      alt={member.name}
                      style={{
                        scale: member.imageScale,
                        translate: member.imageTranslateY ? `0 ${member.imageTranslateY}` : undefined,
                      }}
                      className="w-full h-full object-cover object-top"
                    />
                  )}
                </div>
                <div className="p-7">
                  <h2 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-1">
                    {member.name}
                  </h2>
                  <p className="text-[#1A4D3C] text-sm font-semibold mb-3">
                    {member.title}
                  </p>
                  <p className="text-[#C9A961] text-xs uppercase tracking-[0.2em] mb-4">
                    {member.location}
                  </p>
                  <p className="text-[#6B6B6B] text-sm leading-relaxed">
                    {member.bio}
                  </p>
                  {member.profile && (
                    <details className="group mt-6 border-t border-[#E8E4DC] pt-5">
                      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-semibold text-[#1A4D3C] [&::-webkit-details-marker]:hidden">
                        Read full profile
                        <i className="ri-arrow-down-s-line text-lg transition-transform duration-200 group-open:rotate-180" />
                      </summary>
                      <div className="mt-5 space-y-4 border-t border-[#E8E4DC] pt-5">
                        {member.profile.map((paragraph) => (
                          <p
                            key={paragraph}
                            className="text-[#6B6B6B] text-sm leading-relaxed"
                          >
                            {paragraph}
                          </p>
                        ))}
                        {member.quote && (
                          <blockquote className="border-l-2 border-[#C9A961] pl-4 font-['Cormorant_Garamond'] text-lg italic leading-relaxed text-[#2B2D2F]">
                            &ldquo;{member.quote}&rdquo;
                          </blockquote>
                        )}
                        {member.strategicFocus && (
                          <div className="rounded-md bg-[#F8F6F3] p-4">
                            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#1A4D3C]">
                              Strategic Focus
                            </p>
                            <p className="text-xs font-medium leading-relaxed text-[#6B6B6B]">
                              {member.strategicFocus.join(" • ")}
                            </p>
                          </div>
                        )}
                      </div>
                    </details>
                  )}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
